import createAxios from './api'

const PATH = 'rssp/v1/users'

export default {
  async joinUser() {
    const axios = await createAxios()
    try {
      const resp = await axios.put(`${PATH}`)
      return resp.data
    } catch (error) {

    }
    // const resp = await axios.put(`${PATH}`)
    // return resp.data
    return null
  },

  async createUser(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}`, req)

    return resp.data
  },

  async listUsers(q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async listEnabledUsers() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/enabled`)

    return resp.data
  },

  async updateMyUser(user) {
    const axios = await createAxios()
    await axios.put(`${PATH}/self`, user)
  },

  async updateMyLocale(locale) {
    const axios = await createAxios()
    await axios.put(`${PATH}/self/locale`, locale)
  },

  async updateUser(id, user) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}`, user)
  },

  async getMyUser() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self`)

    return resp.data
  },

  async getUser(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)

    return resp.data
  },

  async getUserSmart(idOrSelf) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${idOrSelf}`)

    return resp.data
  },

  async deleteUser(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  }
}
